import { ExportTypes, type ExportTypeType } from './ExportTypes';

export class ExportType {
    private _type: ExportTypeType = ExportTypes.CSV;
    private _api_endpoint: string;
    private _name: string;

    constructor(_api_endpoint: string, name: string) {
        this._api_endpoint = _api_endpoint;
        this._name = name;
    }

    public setType(type: ExportTypeType): ExportType {
        this._type = type;
        return this;
    }

    public getType(): ExportTypeType {
        return this._type;
    }

    public getApiEndpoint(): string {
        return this._api_endpoint;
    }

    public getOutputFileName(): string {
        return this._name;
    }

    public setOutputFileName(name: string): ExportType {
        this._name = name;
        return this;
    }
}
